<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <router-link to="/belongs">
            <input type="button" :value="cancelButton" class="cancel_button" />
          </router-link>
          <input
            type="button"
            :value="addButton"
            class="finish_button"
            @click="showModal = true"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="post_name detail_content">
            <div class="post_name_label detail_label">
              {{ postNameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('postName')"
            />
          </div>
          <div class="post_code detail_content">
            <div class="post_code_label detail_label">
              {{ postCodeLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('postCode')"
            />
          </div>
          <div class="post_parent detail_content">
            <div class="post_parent_label detail_label">
              {{ postParentLabel }}
            </div>
            <select
              class="drop_down_list"
              @change="inputAddUpdate('parentPostId')"
            >
              <option value=""></option>
              <option disabled selected value="">{{ postName }}</option>
              <option
                v-for="post in posts"
                :value="post.postId"
                :key="post.postId"
              >
                {{ post.postName }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal_window" v-if="showModal">
        <addModalWindow @close="stayClose" @add="addPost"> </addModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import addModalWindow from '../modalWindow/addModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      addButton: '追加',
      postNameLabel: '所属名',
      postCodeLabel: '所属コード',
      postParentLabel: '親所属',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false
    }
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    },
    posts() {
      return this.$store.state.belongs.allPosts
    }
  },
  created() {
    this.$store.dispatch('belongs/clearPost')
    this.$store.dispatch('belongs/setAllPosts')
  },
  components: {
    addModalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    inputAddUpdate(e) {
      this.$store.dispatch('belongs/inputAddUpdate', {
        name: e,
        value: event.target.value
      })
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push('/belongs')
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async addPost(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('belongs/addPost')
        this.$emit('list-reload')
        this.showModal = false
        this.completeWord = '追加しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_360001
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0033') {
            this.failureWord =
              this.errorMsg.MSGCRC0033.name +
              this.errorMsg.MSGCRC0033.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0101') {
            this.failureWord =
              this.errorMsg.MSGCRC0101.name +
              this.errorMsg.MSGCRC0101.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0147') {
            this.failureWord =
              this.errorMsg.MSGCRC0147.name +
              this.errorMsg.MSGCRC0147.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0148') {
            this.failureWord =
              this.errorMsg.MSGCRC0148.name +
              this.errorMsg.MSGCRC0148.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0149') {
            this.failureWord =
              this.errorMsg.MSGCRC0149.name +
              this.errorMsg.MSGCRC0149.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0150') {
            this.failureWord =
              this.errorMsg.MSGCRC0150.name +
              this.errorMsg.MSGCRC0150.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0151') {
            this.failureWord =
              this.errorMsg.MSGCRC0151.name +
              this.errorMsg.MSGCRC0151.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.failureWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.failureWord =
              this.errorMsg.MSGCRC0034.name +
              this.errorMsg.MSGCRC0034.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0034'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0034.name +
            this.errorMsg.MSGCRC0034.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/belongs/belongAdd.vue